import React from 'react';
import { Form } from '../../../../../v2BaseComponents/Form';
import { APITypes } from '../../../../../../primary-record-types';
import { useIsDisabledByParent } from '../../../../../v2BaseComponents/IsDisabledProvider';
import SideDrawerFormContainer, {
    ConfirmDirtyStateFormCloseContainer,
    SideDrawerDirtyFormExitValidationTracker,
} from '../../../../../v2BaseComponents/Form/SideDrawerFormContainer';
import useOrganizationInvitations from '../../../../../../hooks/api/useOrganizationUserInvitations';
import OrganizationInvitationFields from '../../../../../shared/OrganizationInvitations/OrganizationInvitationFields';

export type AddOrganizationInvitationSideDrawerContentOwnProps = {
    onClose: (force: boolean) => void;
};

export type AddOrganizationInvitationSideDrawerContentProps = AddOrganizationInvitationSideDrawerContentOwnProps;

const initialValues: APITypes.organizationService.CreateOrganizationUserInvitationRequest = {
    inviteeEmail: '',
    inviteeFirstName: '',
    inviteeLastName: '',
    inviteeRole: 'agent',
    message: '',
};

const AddOrganizationInvitationSideDrawerContent: React.FC<AddOrganizationInvitationSideDrawerContentProps> = ({
    onClose,
}) => {
    const { isCreatingInvitation, createInvitation } = useOrganizationInvitations({
        onCreateInvitation: () => onClose(true),
    });
    const isDisabled = useIsDisabledByParent(isCreatingInvitation);
    return (
        <ConfirmDirtyStateFormCloseContainer>
            <Form
                fillContainer
                initialValues={initialValues}
                onSubmit={(values) => createInvitation(values)}
                isDisabled={isDisabled}
                forceStackFields
            >
                {({ isSubmitting, handleSubmit }) => {
                    return (
                        <SideDrawerFormContainer
                            isDisabled={isDisabled || isSubmitting}
                            onSubmit={handleSubmit}
                            onCancel={() => onClose(true)}
                        >
                            <SideDrawerDirtyFormExitValidationTracker />
                            <OrganizationInvitationFields isDisabled={isDisabled || isSubmitting} />
                        </SideDrawerFormContainer>
                    );
                }}
            </Form>
        </ConfirmDirtyStateFormCloseContainer>
    );
};

export default React.memo(AddOrganizationInvitationSideDrawerContent);
